import { render, staticRenderFns } from "./TopSpacesTable.vue?vue&type=template&id=42fbc2d0&scoped=true&"
import script from "./TopSpacesTable.vue?vue&type=script&lang=js&"
export * from "./TopSpacesTable.vue?vue&type=script&lang=js&"
import style0 from "./TopSpacesTable.vue?vue&type=style&index=0&id=42fbc2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbc2d0",
  null
  
)

export default component.exports